import React from "react";
import InlineLoader from "../common/InlineLoader";
import EmptyState from "../common/EmptyState";
import "./HowWouldTheySeeIt.scss";

const HowWouldTheySeeIt = ({ hwtNews, hwtLoading, goToCA }) => {
  return (
    <div className="hwt-container">
      <div className="pub-section-lbl" style={{ color: "#12308c", fontWeight: 700, paddingTop: 16 }}>
        <i className="ti ti-users"></i> How Would They See It
      </div>
      <p className="ctf-intro">
        Understand today's news through the lens of thinkers and former Indian personalities.
      </p>
      {hwtLoading && <InlineLoader label="Loading today's story…" />}
      {!hwtLoading && !hwtNews && <EmptyState label="No news available right now." />}
      {!hwtLoading && hwtNews && (
        <div className="hwt-teaser" onClick={goToCA}>
          <div className="hwt-teaser-head">"{hwtNews.title}"</div>
          {hwtNews.shortdescription && (
            <div className="hwt-teaser-desc">{hwtNews.shortdescription}</div>
          )}
          <div className="hwt-teaser-chips">
            {(hwtNews.thinkers || []).map((t) => <span key={t}>{t}</span>)}
          </div>
          <div className="hwt-teaser-cta">How would they see it <i className="ti ti-arrow-right"></i></div>
        </div>
      )}
    </div>
  );
};

export default HowWouldTheySeeIt;